import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import DOMPurify from 'dompurify';

const buttonStyle = { border: '1px solid var(--border)', borderRadius: 6, padding: '6px 9px', background: 'var(--bg-4)', color: 'var(--text-primary)', cursor: 'pointer', fontSize: 11 };

function CardPreview({ content, contentType }) {
  if (contentType === 'image' && /^https?:\/\//i.test(content || '')) {
    return <img src={content} alt="Proposed card" style={{ maxWidth: '100%', maxHeight: 240 }} />;
  }
  return <div className="prose" style={{ overflowX: 'auto', overflowWrap: 'anywhere', fontSize: 12, lineHeight: 1.6 }}>
    {content?.trimStart().startsWith('<')
      ? <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
      : <ReactMarkdown remarkPlugins={[remarkGfm]}>{content || '(empty)'}</ReactMarkdown>}
  </div>;
}

export default function ProposalReview({ proposal, onApprove, onCancel, onModify }) {
  const [showPreview, setShowPreview] = useState(false);
  const title = proposal.payload.title || proposal.before_title;
  return (
    <section style={{ border: '1px solid #8b5cf680', borderRadius: 12, padding: 12, background: 'var(--bg-3)', fontSize: 12 }}>
      <div style={{ color: '#8b5cf6', fontWeight: 700, marginBottom: 6 }}>REVIEW {proposal.action === 'create' ? 'NEW CARD' : 'CARD UPDATE'}</div>
      {proposal.proposed_by_email && <div style={{ color: 'var(--text-muted)', fontSize: 11, marginBottom: 5 }}>Proposed by {proposal.proposed_by_email}</div>}
      <div style={{ fontWeight: 700, color: 'var(--text-primary)' }}>{title}</div>
      <div style={{ color: 'var(--text-secondary)', margin: '7px 0' }}>{proposal.summary}</div>
      <button type="button" onClick={() => setShowPreview(!showPreview)} style={buttonStyle}>
        {showPreview ? 'Hide content' : 'Preview full content'}
      </button>
      {showPreview && (
        <div style={{ maxHeight: 360, overflowY: 'auto', marginTop: 8, color: 'var(--text-secondary)' }}>
          <strong>Proposed content:</strong>
          <CardPreview content={proposal.payload.content} contentType={proposal.payload.content_type} />
          {proposal.action === 'update' && <details style={{ marginTop: 12 }}>
            <summary style={{ cursor: 'pointer', fontWeight: 600 }}>Compare with current card</summary>
            <CardPreview content={proposal.before_content} contentType={proposal.payload.content_type} />
          </details>}
        </div>
      )}
      {proposal.error && <div role="alert" style={{ color: '#ef4444', marginTop: 8 }}>{proposal.error}</div>}
      <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
        <button type="button" disabled={proposal.busy} onClick={onApprove} style={{ ...buttonStyle, background: '#6366f1', color: 'white' }}>Approve</button>
        <button type="button" disabled={proposal.busy} onClick={onModify} style={buttonStyle}>Modify</button>
        <button type="button" disabled={proposal.busy} onClick={onCancel} style={buttonStyle}>Cancel</button>
      </div>
    </section>
  );
}
